import { render, staticRenderFns } from "./channel-options.vue?vue&type=template&id=17617a0d&"
import script from "./channel-options.vue?vue&type=script&lang=js&"
export * from "./channel-options.vue?vue&type=script&lang=js&"
import style0 from "./channel-options.vue?vue&type=style&index=0&id=17617a0d&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports